const loadSloExplode = () => {
  const explode = document.querySelector('.slo-explode');

  if (explode) {
    const sloExploders = document.querySelectorAll('.slo-explode');

    sloExploders.forEach(sloExplode => {
      const items = sloExplode.querySelectorAll('.slo-explode--item');

      const options = {
        threshold: 1,
        rootMargin: '0px 0px 0px 0px'
      };

      const explodeObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      }, options);

      items.forEach(item => explodeObserver.observe(item));
    });
  }
};

export default loadSloExplode;
